import { defineAction } from '~/prix'
import { z } from 'zod'
import collectedAnimalCreateAction from './collectedAnimalCreate.action.json' with { type: 'json' }
import { collectedAnimalObject } from '../collectedAnimalObject'

const collectedAnimalCreateDefinition = defineAction({
  ...collectedAnimalCreateAction,

  input: collectedAnimalObject
    .pick({
      id: true,
      incentiveId: true,
      earringNumber: true,
      species: true,
      weight: true,
      unitValue: true,
      discountValue: true,
    })
    .partial({ id: true })
    .required({ incentiveId: true, earringNumber: true }),
  output: z.object({ id: collectedAnimalObject.shape.id }),
})

export default collectedAnimalCreateDefinition
